"use client"

import { Transgender } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `TransgenderIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const TransgenderIcon = component(Icon)({ as: Transgender })
